import { CampaignManagementQuery } from "../../../../services/query";
import { StoreActionType as Type } from "../../types";

type LogListFilterType = {
    regionId : number,
    campaignId : number,
    email : string,
    beginDate : string,
    endDate : string,
    skipCount : number,
    maxResultCount : number
    sortPropertyName : string,
    sortValue : number
}

export const getLogs : any = (filter : LogListFilterType) => {

    const { regionId, campaignId, email, beginDate, endDate, skipCount, maxResultCount, sortPropertyName, sortValue } = filter;

    return async (dispatch: any) => {
        dispatch({ type: Type.GET_CAMPAIGN_LOG_ACTIVITIES_REQUEST});

        CampaignManagementQuery.GetLogs({ regionId, campaignId, email, beginDate, endDate, skipCount, maxResultCount, sortPropertyName, sortValue })
            .then((response: any) => {
                if (response) {
                    dispatch({ type: Type.GET_CAMPAIGN_LOG_ACTIVITIES_SUCCESS, payload: response.data });
                } else {
                    dispatch({ type: Type.GET_CAMPAIGN_LOG_ACTIVITIES_FAILURE, payload: [] });
                }
            })
            .catch((error: any) => {
                console.error('Error:', error);
                dispatch({ type: Type.GET_CAMPAIGN_LOG_ACTIVITIES_FAILURE, payload: error });
            });
    }
};

type LogFilterType = {
    timeRange: number;
    dateRange: {
        beginDate: string;
        endDate: string;
    };
};

export const setLogFilter = (filter: LogFilterType) => {
    return (dispatch: any) => {
        dispatch({ type: Type.SET_CAMPAIGN_LOG_FILTER, payload: filter });
    };
}